import { get, has, pick } from 'lodash';
import { CURRENCY_USD, COUNTRY_CODE_US, usageTypeMap } from '@/common/constants';
import { navigateToTargetPage } from '@/utils/modal-utils';
import qs from 'qs';
import { mapGetters } from 'vuex';

const CONFIG_KEY = 'iapRedirectToWebInfo';
const IAP_PARAM_KEYS = {
  FirstName: 'firstName',
  LastName: 'lastName',
  Email: 'email',
  RedirectToAppleLink: 'redirectToAppleLink',
  IsFirstMobileRedirect: 'firstMobileRedirect'
};

export const IAP_CURRENCY_WHITE_LIST = [CURRENCY_USD];

const iapInfoObj = get(window.newBillingConfig, CONFIG_KEY, {});

// If the backend provides a value for `isFirstMobileRedirect`,
// it indicates that the current flow was initiated from an in-app redirect (e.g., iOS app to web).
export const isIAPRedirectFromApp = !!get(iapInfoObj, IAP_PARAM_KEYS.IsFirstMobileRedirect, false);

// Determine if the user is in the In-App Purchase (IAP) web redirection flow.
// Starting June 2025, due to Apple policy changes, clients are allowed to redirect users
// from the native app to the web page to purchase plans.
// Because automatic login is not permitted for security reasons,
// a token-based approach is used. The backend populates user info (firstName, lastName, email)
// in `newBillingConfig.iapRedirectToWebInfo` to simulate a logged-in state on the web.
// If `iapRedirectToWebInfo` exists, the user is considered to be in a logged-in state via IAP.
export const isIAPRedirectUser = Object.values(IAP_PARAM_KEYS).some((k) => has(iapInfoObj, k));

export function getIAPAccountInfo() {
  return isIAPRedirectUser
    ? pick(iapInfoObj, [IAP_PARAM_KEYS.FirstName, IAP_PARAM_KEYS.LastName, IAP_PARAM_KEYS.Email])
    : null;
}


function getRedirectBackToAppleClientUrl() {
  const getRedirectUrl = () => {
    const BASE_URL = 'zoomus://zoom.us/router';
    const query = {
      page: 'myprofile',
      source: 'subscription_succeed',
      needDismissPresented: true,
    };
    return BASE_URL + '?' + qs.stringify(query);
  };
  return iapInfoObj[IAP_PARAM_KEYS.RedirectToAppleLink] || getRedirectUrl();
}

export function redirectToClientProfilePage() {
  navigateToTargetPage(getRedirectBackToAppleClientUrl());
}

export const defaultAddressInfo = () => {
  return isIAPRedirectUser && isIAPRedirectFromApp
    ? {
        country: COUNTRY_CODE_US,
        usageType: usageTypeMap.personal,
      }
    : {};
};

export function getRootDomain() {
  const hostname = window.location.hostname;

  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname) || hostname === 'localhost') {
    return hostname;
  }

  const parts = hostname.split('.');

  if (parts.length >= 2) {
    const tld = parts.pop();
    const domain = parts.pop();
    return `${domain}.${tld}`;
  }

  return hostname;
}

export function iapLoadingLayerMixin() {
  return {
    data() {
      return {
        LoadingSpikes: require('@/assets/loading-spikes.svg'),
        locationDomain: [window.location.protocol, getRootDomain()].join('//')
      }
    },
    computed: {
      ...mapGetters(["flowInitIsReady"]),
      showIAPRedirectLoading() {
        return isIAPRedirectUser && isIAPRedirectFromApp && !this.flowInitIsReady
      }
    }
  }
}